






























import { Component, Vue, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import InProgressOfferData from '@/ts/InProgressOfferData';
import EditPresentation from '@/components/Admin/Panels/EditPresentation.vue';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import DateMethods from '@/mixins/DateMethods.vue';

import { dateFormat, dateTimeFormat } from '@/ts/DefaultTableConfigs';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        EditPresentation,
        FlexibleTable,
    },
    computed: {
        ...mapGetters({
            editPresentationVisibility: 'PresentationFlows/getEditPresentationVisibility',
        }),
    },
})
export default class InProgressOffers extends Mixins(DateMethods) {
    public tableEntity: string = 'InProgressOffers';

    constructor() {
        super();
    }

    get columns(): any {
        return  [
            { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
            { name: 'project', label: this.$t('general.project', 'Project'), align: 'left', field: 'project', sortable: true, required: false },
            { name: 'sentDate', label: this.$t('general.sent-date', 'Sent date'), align: 'left', field: 'sentDate', sortable: true, required: false, filterType: 'date', dateFormat },
            { name: 'deadLineDate', label: this.$t('general.deadline', 'Deadline'), align: 'left', sortable: true, required: false, filterType: 'date',
                field: (row: any) => {
                    return this.getLocalUTCOffsetString(row.deadLineDate, 'L - LT');
                },
                sort: (a: any, b: any) => {
                    const aTimestamp = (a !== '' && a !== null) ? this.getUnixTime(a) : 0;
                    const bTimestamp = (b !== '' && b !== null) ? this.getUnixTime(b) : 0;

                    return aTimestamp - bTimestamp;
                },
            },
            { name: 'moveInDate', label: this.$t('general.movein', 'Move in'), align: 'left', field: 'moveInDate', sortable: true, required: false, filterType: 'date', dateFormat },
            { name: 'unitId', label: this.$t('general.unit-id', 'Unit ID'), align: 'left', field: 'unitId', sortable: true, required: false },
            { name: 'address', label: this.$t('general.address', 'Address'), align: 'left', field: 'address', sortable: true, required: false },
            { name: 'type', label: this.$t('general.type', 'Type'), align: 'left', field: 'type', sortable: true, required: false },
            { name: 'applicants', label: this.$t('general.applicants', 'Applicants'), align: 'left', field: 'applicants', sortable: true, required: false },
            { name: 'groups', label: this.$t('general.groupings', 'Groups'), align: 'left', field: 'groups', sortable: true, required: false, filterType: 'array' },
            { name: 'createdBy', label: this.$t('general.created-by', 'Created by'), align: 'left', field: 'createdBy', sortable: true, required: false },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'project',
                'sentDate',
                'deadLineDate',
                'address',
                'applicants',
                'groups',
                'type',
            ],
        };
    }

    get inProgressOffers(): InProgressOfferData[]  {
        return this.$store.getters['PresentationFlows/getInprogressOffers'];
    }

    public editPresentationModal(presentationId: number) {
        this.$store.commit(Mutations.SET_EDIT_PRESENTATION_VISIBILITY, true);

        this.$store.dispatch(Actions.FETCH_CURRENT_EDIT_PRESENTATION, presentationId);
    }

    public goToUnit(id: number) {
        const presentation = this.inProgressOffers.find((inProgressOffer: InProgressOfferData) => inProgressOffer.id === id);

        this.$router.push({ name: 'admin-units', params: { unitId: presentation.propertyId.toString()}});
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ALL_INPROGRESS_OFFERS, {project: this.$store.getters['PresentationFlows/getCurrentProject']});
    }
}
